import { combineReducers } from 'redux';
import { associationPage, associationPages } from './associationPagesReducer';
import { autocomplete } from './autocompleteReducer';
import { blog } from './blogReducer';
import { book } from './bookReducer';
import { bundle } from './bundleReducer';
import cookies from './cookies';
import { dealDetail } from './dealDetailReducer';
import { dealsSearch } from './dealsSearchReducer';
import { deploy } from './deployReducer';
import { employees } from './employeesReducer';
import { featurePromos } from './featurePromoReducer';
import { flags } from './flagsReducer';
import { form } from './formReducer';
import { homepage } from './homepageReducer';
import { archive, landingPage } from './landingPageReducer';
import { listType } from './listReducer';
import { loading } from './loadingReducer';
import { modal } from './modalReducer';
import { navigationDrawer } from './navigationDrawerReducer';
import { place } from './placeReducer';
import { reviews } from './reviewsReducer';
import { searchV2 } from './searchV2Reducer';
import { settings } from './settingsReducer';
import { services } from './servicesReducer';
import { serviceCategories } from './serviceCategoriesReducer';
import { ssrPlace } from './ssrPlaceReducer';
import { turnstile } from './turnstileReducer';
import { users } from './usersReducer';

export default combineReducers({
  users,
  place,
  ssrPlace,
  reviews,
  modal,
  searchV2,
  services,
  serviceCategories,
  employees,
  homepage,
  archive,
  landingPage,
  book,
  form,
  loading,
  listType,
  settings,
  autocomplete,
  deploy,
  blog,
  bundle,
  featurePromos,
  navigationDrawer,
  flags,
  turnstile,
  associationPage,
  associationPages,
  cookies,
  dealDetail,
  dealsSearch,
});
